import { Fragment } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Table, Pagination, SectionTitle } from '../../../components';
import { withPagination } from '../../../hoc';
import round from '../../../utils/roundNumber';
import styles from './index.module.css';

const SheetPileCptSummary = ({
    dataToPaginate = [],
    pagination,
    paginationHelpers = {},
}) => {
    return (
        <Fragment>
            {dataToPaginate.length > 0 && (
                <Row className={styles.row}>
                    <Col xs={12}>
                        <SectionTitle
                            title={`Nośność pionowa grodzic na podstawie metody francuskiego Centralnego Laboratorium Dróg i Mostów w oparciu o wyniki sondowań CPT`}
                        />
                        <Table className={styles.table}>
                            <thead>
                                <tr>
                                    <th>
                                        Nr<br></br>[-]
                                    </th>
                                    <th title="Nazwa pliku">
                                        Nazwa pliku<br></br>[-]
                                    </th>
                                    <th title="Profil gruntowy">
                                        Profil gruntowy<br></br>[-]
                                    </th>
                                    <th title="Rodzaj grodzic">
                                        Typ grodzicy<br></br>[-]
                                    </th>
                                    <th title="Rzędna">
                                        z<br></br>[m.p.p.t.]
                                    </th>
                                    <th title="Charakterystyczna nośność podstawy">
                                        R<sub>b,k</sub>
                                        <br></br>[kN]
                                    </th>
                                    <th title="Charakterystyczna nośność pobocznicy">
                                        R<sub>s,k</sub>=&Sigma;R<sub>s,k,i</sub>
                                        <br></br>[kN]
                                    </th>
                                    <th title="Współczynnik bezp. przy ściskaniu">
                                        &gamma;<sub>b,s,t</sub>
                                        <br></br>[-]
                                    </th> 
                                    <th title="Nośność obliczeniowa na wciskanie">
                                        R<sub>c,d</sub>
                                        <br></br>[kN]
                                    </th>
                                    {
                                    dataToPaginate.map(ele =>  ele.results.results.calculations.sheetPileNumbers).some(ele => ele > 1) &&
                                    <th title="Nośność obliczeniowa na wciskanie jednego zestawu">
                                        R<sub>c,d,single</sub>
                                        <br></br>[kN]
                                    </th>
                                    }
                                    {
                                    dataToPaginate.map(ele =>  ele.results.results.calculations.sheetPileList).some(ele => ele === true) &&
                                    <th title="Nośność obliczeniowa na wciskanie na 1 metr">
                                        R<sub>c,d,meter</sub>
                                        <br></br>[kN/mb]
                                    </th>
                                    }
                                </tr>
                            </thead>
                            <tbody className={styles.tbody}>
                                {dataToPaginate.map((element, index, arr) => {
                                    return (
                                        <tr className={styles.tr} key={index}>
                                            <td>{paginationHelpers.countingItemsPerPage + index + 1}</td>
                                            <td>{element.projectName}</td>
                                            <td>{element.profileName}</td>
                                            <td>{element.results.results.calculations.sheetPileType}</td>
                                            <td>{round(element.results.results.currentCapacity.z, 2)}</td>
                                            <td>{round(element.results.results.currentCapacity.Rbk, 2)}</td>
                                            <td>{round(element.results.results.currentCapacity.Rsk, 2)}</td>
                                            <td>{round(element.results.results.calculations.yt, 2)}</td>
                                            <td>{round(element.results.results.currentCapacity.Rcd, 2)}</td>
                                            {
                                                element.results.results.calculations.sheetPileNumbers > 1 &&

                                                <td>{round(element.results.results.currentCapacity.Rcd_single, 2)}</td>

                                            }
                                            {
                                                element.results.results.calculations.sheetPileList 
                                                ?
                                                <td>{round(element.results.results.currentCapacity.Rcd_meter, 2)}</td>
                                                :
                                                <td>-</td>
                                            }
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </Table>
                        {paginationHelpers.totalPages > 1 && (
                            <Pagination
                                currentPage={pagination.currentPage}
                                itemsPerPage={pagination.itemsPerPage}
                                totalItems={paginationHelpers.allItemsLength}
                                nextPage={paginationHelpers.nextPage}
                            />
                        )}
                    </Col>
                </Row>
            )}
        </Fragment>
    );
};

export default withPagination({
    component: SheetPileCptSummary,
    returnAllCollection: false,
    paginationState: {
        currentPage: 1,
        itemsPerPage: 15,
    },
});
